import { Box, Button, Typography } from "@mui/material";

export interface ErrorBoundaryProviderProps {
	error: Error;
	reset: () => void;
}

const ErrorBoundaryProvider = ({ error, reset }: ErrorBoundaryProviderProps) => {
	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			height="100vh"
			textAlign="center"
		>
			<Typography variant="h1" gutterBottom={true}>
				V systému SŽT IMM nastala chyba
			</Typography>
			<Typography variant="body1" gutterBottom={true}>
				Moc se omlouváme za vzniklou nepříjemnost, můžete zkusit načíst stránku znovu nebo zkopírovat chybovou hlášku a
				s popisem situace, která k chybě vedla chybu nahlásit za pomoci tlačítka nahlásit chybu v horním panelu.
			</Typography>
			<Box mt={2}>
				<Button variant="contained" color="primary" onClick={reset}>
					znovu načíst
				</Button>
			</Box>
			<Box mt={2}>
				<details style={{ whiteSpace: "pre-wrap" }}>
					{error.name}
					<br />
					{error.message}
					<br />
					{error.stack}
				</details>
			</Box>
		</Box>
	);
};

export default ErrorBoundaryProvider;
